import { useState } from "react";
import { X } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { Button } from "@web/ui/Button";
import { Modal } from "@web/ui/Modal";
import { UnsubscribeControl } from "./UnsubscribeControl";

/** Opening this dialog only reads cached list headers; the owner chooses any outward action. */
export function UnsubscribeButton({
  accountId,
  accountEmail,
  address,
  name,
  threadKey,
  onOpen,
}: {
  accountId: string;
  accountEmail: string;
  address: string;
  name?: string;
  threadKey: string;
  onOpen?: () => void;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        size="sm"
        variant="ghost"
        onClick={() => {
          onOpen?.();
          setOpen(true);
        }}
        aria-label={`Unsubscribe from ${name || address}`}
      >
        Unsubscribe…
      </Button>
      <Modal open={open} onClose={() => setOpen(false)} label="Unsubscribe">
        <div className="flex w-[min(520px,90vw)] flex-col gap-4 p-5">
          <div className="flex items-start justify-between gap-3">
            <h2 className="text-2xl">Unsubscribe from {name || address}?</h2>
            <Button
              size="sm"
              variant="ghost"
              aria-label="Close unsubscribe"
              onClick={() => setOpen(false)}
            >
              <X aria-hidden className="size-4" />
            </Button>
          </div>
          <p className="text-sm break-words">
            <strong>{name || address}</strong>
            {name ? (
              <>
                <br />
                {address}
              </>
            ) : null}
          </p>
          <p className="text-sm text-muted">Mailbox: {accountEmail}</p>
          <UnsubscribeControl
            accountId={accountId}
            address={address}
            showUnavailable
            confirmOnOpen
            onCancel={() => setOpen(false)}
            onDraftOpened={() => setOpen(false)}
          />
          <div className="flex flex-wrap items-center justify-between gap-2">
            <Link
              to="/t/$key"
              params={{ key: threadKey }}
              onClick={() => setOpen(false)}
              className="text-sm text-accent-text underline underline-offset-2"
            >
              Read the email
            </Link>
          </div>
        </div>
      </Modal>
    </>
  );
}
